import {
  ADVANCED_FILTER,
  PERSONAL_FILTER,
  PURCHASE_FILTER,
} from 'Pods/SearchPage/Store/constants'

export const SECTION = {
  ALL: 'all',
  GENERAL: 'general',
  STATUS: 'status',
}

const generalFilters = [
  {
    value: ADVANCED_FILTER.COLLECTIONS_ONLY,
    labelKey: 'packs',
  },
  {
    value: ADVANCED_FILTER.HAS_MARMOSET,
    labelKey: 'has_marmoset',
  },
  {
    value: ADVANCED_FILTER.HAS_VIDEO,
    labelKey: 'has_video',
  },
]

const statusFilters = [
  {
    value: PURCHASE_FILTER.PURCHASED_MODELS_ONLY,
    labelKey: 'purchased',
  },
  {
    value: PERSONAL_FILTER.IN_CART_ONLY,
    labelKey: 'in_cart',
  },
  {
    value: PERSONAL_FILTER.WISH_LIST_ONLY,
    labelKey: 'wishlist',
  },
  {
    value: PERSONAL_FILTER.LIKED_MODELS_ONLY,
    labelKey: 'liked',
  },
]

const hidePurchasedFilters = [
  {
    value: PURCHASE_FILTER.HIDE_OWNED_MODELS,
    labelKey: 'hide_purchased',
  },
]

const buildFilters = (translate, filters) => filters.map(filter => ({
  value: filter.value,
  label: translate(`search_page.filters.advanced.${filter.labelKey}`),
}))

export const getGeneralFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.general_group_label'),
  filters: buildFilters(translate, generalFilters),
}]

export const getStatusFiltersConfig = (translate) => [{
  label: translate('search_page.filters.advanced.status_group_label'),
  filters: buildFilters(translate, statusFilters),
}]

// Unlabeled: Figma 3183:36396 sets it apart from Status with a divider only.
export const getHidePurchasedFiltersConfig = (translate) => [{
  label: '',
  filters: buildFilters(translate, hidePurchasedFilters),
}]
